import type { DeleteProductsFromFavouriteListInput } from '../../request/backendApi/favourites/deleteProductsFromFavouriteList';
import { requestDeleteProductsFromFavouriteList } from '../../request/backendApi/favourites/deleteProductsFromFavouriteList';

export const deleteProductsFromFavouriteList = (input: DeleteProductsFromFavouriteListInput) =>
  requestDeleteProductsFromFavouriteList(input);
